var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranchesOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M610.001-130.001v-120h-160v-400H349.999v120H90.001v-299.998h259.998v120h260.002v-120h259.998v299.998H610.001v-120H509.999v340.002h100.002v-120h259.998v299.998H610.001Zm-460.002-640v180.002-180.002Zm520 400v180.002-180.002Zm0-400v180.002-180.002Zm0 180.002h140.002v-180.002H669.999v180.002Zm0 400h140.002v-180.002H669.999v180.002Zm-520-400h140.002v-180.002H149.999v180.002Z",
    fill: "#5D616D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchesOutline);
export default __webpack_public_path__ + "static/media/Branches Outline.6a08ab3d8a232023b01c51dc4ea2173c.svg";
export { ForwardRef as ReactComponent };